import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { ORAOutboundResponse } from '../models/oraoutbound.model';
import { IdName } from '../interfaces/pricematrixmodel';
@Injectable({
  providedIn: 'root'
})
export class OraoutboundService {

  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) { }
  getORAOutboundList(startDate: string, endDate: string): Observable<ORAOutboundResponse[]> {
    var oraoutboundUrl = `${this.baseUrl}trashcompactors`;      
    var params = new URLSearchParams();
    params.append('startDate', startDate);
    params.append('endDate', endDate);
    var url = `${oraoutboundUrl}?${params.toString()}`;
    return this.http.get<ORAOutboundResponse[]>(url);           
  }

  getoRAOutboundById(id: number): Observable<ORAOutboundResponse> {
    var oraoutboundByIdUrl = `${this.baseUrl}trashcompactors/${id}`;        
    return this.http.get<ORAOutboundResponse>(oraoutboundByIdUrl);           
  }

  saveOrAOutbound(data: ORAOutboundResponse): Observable<boolean> {
    var saveOraoutboundUrl = `${this.baseUrl}trashcompactors`;        
    return this.http.post<boolean>(saveOraoutboundUrl, data);           
  }

  deleteORAOutbound(id: number): Observable<boolean> {
    var deleteUrl = `${this.baseUrl}trashcompactors/${id}`;        
    return this.http.delete<boolean>(deleteUrl);           
  }

  getRecyclingTypes(): Observable<IdName[]> {
    var recyclingTypesUrl = `${this.baseUrl}trashcompactors/GetRecyclingRevenueTypes`;        
    return this.http.get<IdName[]>(recyclingTypesUrl);           
  }
}
